import { getRevealPhrasing, getRevealSubtitle } from '../lib/content.js';
import { playReveal } from '../lib/audio.js';
import { isVictorCorthals } from '../lib/specialCases.js';

function escapeHtml(s) {
  return s.replace(/[&<>"]/g, (c) => ({ '&': '&amp;', '<': '&lt;', '>': '&gt;', '"': '&quot;' }[c]));
}

function reducedMotion() {
  return window.matchMedia('(prefers-reduced-motion: reduce)').matches;
}

function formatDate(ts) {
  const d = ts ? new Date(ts * 1000) : new Date();
  const mm = String(d.getMonth() + 1).padStart(2, '0');
  const dd = String(d.getDate()).padStart(2, '0');
  return `${mm}.${dd}.${d.getFullYear()}`;
}

export async function runReveal(root, { name, caseNumber, revealLineId, createdAt, durationMs = 1200 }) {
  const victor = isVictorCorthals(name);
  const headline = victor
    ? `${name}, you are 100% NOT gay.`
    : await getRevealPhrasing(revealLineId, name);
  const subtitle = victor
    ? 'The anomaly has been re-verified three times. We stand by these findings.'
    : await getRevealSubtitle(revealLineId);
  const badge = victor ? '✗' : '✓';

  root.innerHTML = `
    <div class="reveal-page${reducedMotion() ? ' reduced' : ''}${victor ? ' victor' : ''}" data-test="reveal">
      <div class="reveal-flash"></div>
      <div class="reveal-content">
        <div class="reveal-badge" data-test="badge">${badge}</div>
        <h1 class="reveal-headline" data-test="headline">${escapeHtml(headline)}</h1>
        <div class="reveal-meta">${victor ? 'Confirmed' : 'Verified'} · ${formatDate(createdAt)} · Case #${escapeHtml(caseNumber)}</div>
        <p class="reveal-subtitle" data-test="subtitle"><em>"${escapeHtml(subtitle)}"</em><br /><span class="subtitle-attribution">— Gay Certification Board</span></p>
      </div>
    </div>
  `;

  if (!reducedMotion()) {
    requestAnimationFrame(() => {
      root.querySelector('.reveal-page').classList.add('animate');
      playReveal();
    });
  }
  await new Promise((r) => setTimeout(r, durationMs));
}
